import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["children"];
import PropTypes from 'prop-types';
import React from 'react';
import { withIcon } from '../Icon';
var innerSvg = '<path d="M16,28A12,12,0,1,1,28,16,12,12,0,0,1,16,28m0,2A14,14,0,1,0,2,16,14,14,0,0,0,16,30Z"/><path d="M17.41,16l4.3-4.29a1,1,0,0,0-1.42-1.42L16,14.59l-4.29-4.3a1,1,0,0,0-1.42,1.42L14.59,16l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L16,17.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z"/>';
export var CloseCircleOutlineSVG = function CloseCircleOutlineSVG(_ref) {
  var children = _ref.children,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 32 32"
  }, rest), children, /*#__PURE__*/React.createElement("g", {
    stroke: "none",
    dangerouslySetInnerHTML: {
      __html: innerSvg
    }
  }));
};
CloseCircleOutlineSVG.propTypes = process.env.NODE_ENV !== "production" ? {
  children: PropTypes.node
} : {};
export default withIcon(CloseCircleOutlineSVG);